const DEFAULT_COMPANY_THEME_KEY = 'default';

const defaultTheme = {
  '--app-canvas': '#F9FAFB',
  '--app-surface': '#FFFFFF',
  '--app-card': '#FFFFFF',
  '--app-sidebar': '#FFFFFF',
  '--app-sidebar-active': '#DBEAFE',
  '--app-primary': '#1D4ED8',
  '--app-accent': '#2563EB',
  '--app-border': '#E5E7EB',
  '--app-text': '#111827',
  '--app-text-muted': '#6B7280',
  '--app-status-active-bg': '#DCFCE7',
  '--app-status-active-text': '#166534',
  '--app-status-reserved-bg': '#DBEAFE',
  '--app-status-reserved-text': '#1D4ED8',
  '--app-status-review-bg': '#FEF3C7',
  '--app-status-review-text': '#92400E',
  '--app-status-blocked-bg': '#FFEDD5',
  '--app-status-blocked-text': '#C2410C',
  '--app-status-banned-bg': '#FEE2E2',
  '--app-status-banned-text': '#B91C1C',
};

const upsTheme = {
  '--app-canvas': '#F6F2EC',
  '--app-surface': '#FFFDF9',
  '--app-card': '#FFFFFF',
  '--app-sidebar': '#FFFDF9',
  '--app-sidebar-active': '#F3E3B0',
  '--app-primary': '#351C15',
  '--app-accent': '#FFB500',
  '--app-border': '#E6DED2',
  '--app-text': '#1D1D1B',
  '--app-text-muted': '#6B625A',
  '--app-status-active-bg': '#E3F5E8',
  '--app-status-active-text': '#1E6B3A',
  '--app-status-reserved-bg': '#E8EEF8',
  '--app-status-reserved-text': '#2F5D9F',
  '--app-status-review-bg': '#FFF1CC',
  '--app-status-review-text': '#8A5A00',
  '--app-status-blocked-bg': '#FDE7D7',
  '--app-status-blocked-text': '#B5531B',
  '--app-status-banned-bg': '#FBE1E1',
  '--app-status-banned-text': '#A12A2A',
};

export const companyThemes = {
  [DEFAULT_COMPANY_THEME_KEY]: defaultTheme,
  ups: upsTheme,
};

export { DEFAULT_COMPANY_THEME_KEY };

export function getCompanyTheme(themeKey) {
  if (!themeKey || !companyThemes[themeKey]) {
    return companyThemes[DEFAULT_COMPANY_THEME_KEY];
  }

  return companyThemes[themeKey];
}
